import { useCallback, useState } from "react";
import { getHolidays } from "../../../components/holidays/functions";

export function useHolidaysSearch(user) {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const search = useCallback(async () => {
    if (!user?.token) {
      return;
    }

    setLoading(true);
    setError(null);

    const data = await getHolidays(user.token);

    if (data?.type === "error") {
      setError(data);
      setHolidays([]);
    } else if (data?.type === "success") {
      setHolidays(data.data ?? []);
    } else {
      setHolidays([]);
    }

    setLoading(false);
  }, [user?.token]);

  const refresh = useCallback(() => search(), [search]);

  return { holidays, loading, error, search, refresh };
}
